import "./SelectButton.css";
import React, { useState, useRef, useEffect } from "react";
import { Button, Typography } from "@mui/material";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuList from '@mui/material/MenuList';
import Grow from '@mui/material/Grow';


const SelectButton = ({children, setSelectedItem, buttonText }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleItemClick = (event, item) => {
    setSelectedItem(item);
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };


  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  const prevOpen = React.useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <div>
      <Button 
        className="selector-button"
        variant="contained"
        id="selector-button"
        aria-controls={open ? 'composition-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleToggle}
        ref={anchorRef}
        sx={{ minHeight: 0, minWidth: 0, padding: 0, justifyContent: "space-between", backgroundColor: 'white', color: 'black', borderRadius: '15px'}}
      >
        <Typography style={{marginRight: 10, marginLeft: 10, fontWeight: 'bold'}} 
          sx={{
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 1,
          }}
        >{buttonText}</Typography>
        <div className="selector-icon">
        {open ? <ExpandLess  /> :
          <ExpandMore />}
        </div>
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
        style={{zIndex: 5}}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom-start' ? 'left top' : 'left bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList 
                  autoFocusItem={open} 
                  onKeyDown={handleListKeyDown} 
                  aria-labelledby="selector-button"
                  id="composition-menu"
                  component={'div'}
                >
                  {children(handleItemClick)}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
      )}
      </Popper>
    </div>
  );
}

export default SelectButton;